 <div class="col-xs-12 bottom-spacing">
     <div class='pull-left'>
         <div *ngIf="messages.length > 0" class="btn-group" ngbDropdown is-open="status.isopen">
             <button id="more-actions-menu-button" type="button" class="btn btn-primary" ngbDropdownToggle>
                 {{LOCALIZATION.actions}}
             </button>
             <ul class="dropdown-menu custom-drop" ngbDropdownMenu aria-labelledby="more-actions-menu-button" role="menu">
                 <li role="menuitem"><a title="Mark all as read" (click)="readAllMessages()" class="pointMe accent-color" >{{LOCALIZATION.messagesReadAll}}</a></li>
                 <li class="hidden-md hidden-lg" role="menuitem"><a title="Delete" (click)="deleteMessages()" class="pointMe text-red" >{{LOCALIZATION.deleteItem}}</a></li>
                 <li role="menuitem"><a title="Delete all messages" (click)="deleteAllMessages()" class="pointMe text-red" >{{LOCALIZATION.deleteMessages}}</a></li>
             </ul>
         </div>
         <button 
         	*ngIf="messages.length > 0" 
         	[disabled]="selectedMessageIds.length == 0" 
         	(click)="deleteMessages()" 
         	class="btn btn-danger hidden-xs hidden-sm" 
         	title="Delete messages" style="margin-left: 4px;">
         		{{LOCALIZATION.deleteItem}}
         </button>
         <button 
         	(click)="refresh()" 
         	class="btn btn-primary" 
         	title="Refresh messages" style="margin-left: 4px;">
         		{{LOCALIZATION.refresh}} <i class="fa fa-refresh"></i>
         </button>
     </div>
     <div class="btn-group pull-right" role="group">
         <button class="btn btn-default" [disabled]="messagesPagination.first" (click)="prevPage()">{{LOCALIZATION.previous}}</button>
         <button class="btn btn-default" [disabled]="messagesPagination.last" (click)="nextPage()">{{LOCALIZATION.next}}</button>
     </div>
     <div class='pull-right'><h5 style="padding-right: 16px;">{{ LOCALIZATION.messagesTotal | formatString: totalMessageCount }}</h5></div>
 </div>
 <div class="col-xs-12 bottom-spacing">
     <div class="list-group messages-group">
         <div class="list-group-item pointMe" *ngFor="let obj of messages; let i = index;">
             <div class="row" [ngClass]="{'text-bold': obj.read == false}" style="font-size: 12px">
                 <div class="col-xs-1">
                     <label class="control control--checkbox">
                         <input [(ngModel)]="obj.selected" (click)="toggleMessage(obj.id)" type="checkbox"/>
                         <div class="control__indicator"></div>
                     </label>
                 </div>
                 <!-- normal date display -->
                 <div class="col-xs-3 hidden-xs truncate" (click)="openMessage(i)">{{obj.created}}</div>
                 <!-- show more of the date for extra small screens -->
                 <div class="col-xs-4 visible-xs-inline-block truncate" (click)="openMessage(i)">{{obj.created}}</div>
                 <div [ngClass]="{'col-xs-2': !obj.open, 'col-xs-8': obj.open}" class="hidden-xs truncate" (click)="openMessage(i)">{{obj.messageObj.type}}</div>
                 <div class="col-xs-6 truncate" [ngClass]="{'hide': obj.open}" (click)="openMessage(i);">{{obj.messageObj.message}}</div>
             </div>
             <div *ngIf="obj.open" class="row top-spacing">
                 <div class="col-xs-12" style="overflow-wrap: break-word;" (click)="obj.action(obj.arg)">{{obj.messageObj.message}}</div>
             </div>
         </div>
     </div>
 </div>
 